import { useQuery } from "@tanstack/react-query";
import RevealReportContent from "components/organisms/pregnancy/RevealReportContent";
import { PregnancyAnnounceReportModel } from "models/pregnancyAnnounceReportModel";
import { useSearchParams } from "react-router-dom";
import { getRequest } from "util/request/request";
import { Helmet } from "react-helmet-async";
import { API_IMAGE_CONTEXT } from "constants/api";

const RevealReportShare = () => {
  const [searchParams] = useSearchParams();

  const sharedUsn = searchParams.get("encUsn");

  const { data } = useQuery<PregnancyAnnounceReportModel>({
    queryKey: ["pregnancyAnnounceReport", "share", sharedUsn],
    queryFn: () =>
      getRequest({
        url: "/api/p/sharedDiary/pregnancyReady/pregnancyAnnounceReport",
        params: { sharedUsn },
      }),
  });

  return (
    <>
      <Helmet>
        <meta property="og:title" content="열달후에 - 임밍아웃" />
        <meta property="og:description" content="아기와 나의 첫 번째 이야기" />
        <meta
          property="og:image"
          content={`${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/img_share_story.png`}
        />
      </Helmet>
      <RevealReportContent data={data} />
    </>
  );
};

export default RevealReportShare;
